import { actions } from './data'

export function languageChanged(locale) {
    return actions.localized.languageChanged(locale)
}

export function steamChanged(steamStartup) {
    return actions.steam.setSteam(steamStartup)
}

export function setProgress(serverName, progress) {
    return actions.progress.setProgress(serverName, progress)
}

export function setProgressMessage(message) {
    return actions.progress.setProgressMessage(message)
}

export function setServerName(name, shortName) {
    return actions.serverNames.setServerName(name, shortName)
}

export function setClientVersion(version) {
    return actions.versions.setClientVersion(version)
}

export function setLauncherVersion(version) {
    return actions.versions.setLauncherVersion(version)
}

export function setUiVersion(version) {
    return actions.versions.setUiVersion(version)
}



// WEBPACK FOOTER //
// ./src/features/LoadingBar/actions.js